import React from 'react'

export default function Title() {
  return (
    <div className='title'>
        <h2 data-scroll data-scroll-repeat>
            <span data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.15">D</span>
            <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.095"
            >R</span>
            <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.085"
            >I</span>
            <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.075"
            >N</span>
            <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.065"
            >K</span>
             <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.055"
            > </span>
             <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.045"
            >U</span>
             <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.035"
            >P</span>
             <span
            data-scroll
            data-scroll-speed="5"
            data-scroll-delay="0.025"
            >!</span>
        </h2>
    </div>
  )
}
